import { getRandomAlphaNumericString } from "../../../utility/Utility";

export default class Template1 {
  static getData() {
    return {
      metaData: null,
      scripts: null,
      hash: getRandomAlphaNumericString(),
      designElements: [
        {
          type: "Icon",
          value: [
            {
              title: "",
              description: "",
              icon:
                "https://s3.ap-southeast-1.amazonaws.com/cdn-crm-common-env/report/thumbnail/21806/1622616405313_deskera-logo-512.png",
            },
          ],
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            marginTop: 14,
            marginBottom: 2,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            alignSelf: "center",
            overflow: "hidden",
            iconSize: 60,
            cellSpacing: 6,
            iconRadius: 0,
            titleColor: "#000000",
            titleSize: 14,
            descriptionColor: "#837c7c",
            descriptionSize: 14,
          },
        },
        {
          type: "Text",
          value:
            "RESPONSE TO AN INQUIRY ABOUT THE POSITION",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "center",
            fontWeight: "bold",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 16,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "center",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Date",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Address",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Dear",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 26,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Thank you for inquiring about the position of _______ at the University of Wisconsin-Stevens Point.  Enclosed is a full position description.",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 6,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Under a court-approved settlement and Wisconsin Statutes, we are required to provide a list of all nominees and applicants except for those who have requested in writing that their identity not be revealed. If you apply for this position and do not want your name to be released, you must send a written request to UWSP’s Equity & Affirmative Action (EAA) Office, 210 Old Main.  Persons agreeing to be final candidates will have their identity (name, address, current position) revealed should anyone request that information.",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Once again, we appreciate your interest in this opening and look forward to receiving your application.  Please contact me if you have any questions regarding our position.",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Sincerely,",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 18,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "NAME OF CHAIR OF SEARCH & SCREEN COMMITTEE",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 16,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 20,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Enclosure",
          style: {
            width: "100%",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        }
      ],
    };
  }
}
